import { FunctionComponent } from "react";
import "./PoolPageDetails.scss";
import RangeSlider from "./../../../components/RangeSlider";
import PoolIcon from "./images/pool-icon.svg";
import LiquidityIcon from "./images/liquidity-icon.svg";
import LockIcon from "./images/lock-icon.svg";

type PoolPageDetailsProps = {
    filled: number;
};

const PoolPageDetails: FunctionComponent<PoolPageDetailsProps> = ({
    filled,
}) => {
    return (
        <>
            <div className='pool-page-details'>
                <div className='pool-page-name-details'>
                    <div className='project-details'>
                        <img src={PoolIcon} alt='pool-icon' />
                        <div className='project-data'>
                            <span className='brand-color-white project-title'>
                                Project Name
                            </span>
                            <span className='brand-color project-status'>
                                Status: Opne/Closed
                            </span>
                            <span className='brand-color-white project-listing'>
                                Listing: May 05, 2021
                            </span>
                        </div>
                    </div>
                    <div className='project-dates'>
                        <span className='start-date brand-color-white'>
                            Start Date: May 05, 2021 [00:00 UTC]
                        </span>
                        <span className='end-date brand-color-white'>
                            End Date: May 07/, 2021 [11:59 UTC]
                        </span>
                    </div>
                    <div className='project-token'>
                        <span className='brand-color-white'>
                            Token Contract Address:{" "}
                        </span>
                        <span className='brand-color'>
                            0xc0ba369c8db6eb3924965e5c4fd0b4c1b91e305f
                        </span>
                    </div>
                    <div className='lock-details'>
                        <div className='liquidity-lock'>
                            <span className='brand-color-white'>
                                Liquidity Lock
                            </span>
                            <div className='liquidity-details'>
                                <img src={LiquidityIcon} alt='liquidity-icon' />
                                <div>
                                    <span className='brand-color-white'>
                                        5%
                                    </span>
                                    <button className='btn btn-brand'>
                                        VIEW HERE
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='lockup-duration'>
                            <span className='brand-color-white'>
                                Lockup Duration
                            </span>
                            <div className='lockup-details'>
                                <img src={LockIcon} alt='liquidity-icon' />
                                <span className='brand-color-white'>365</span>
                                <span className='brand-color'>Days</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='pool-page-vote-details'>
                    <div className='vote-details'>
                        <div className='yes-vote'>
                            <span className='brand-color-white vote-header'>
                                Yes Votes
                            </span>
                            <span className='brand-color vote-value'>
                                75687 BLC
                            </span>
                        </div>
                        <div className='no-vote'>
                            <span className='brand-color-white vote-header'>
                                No Votes
                            </span>
                            <span className='brand-color vote-value'>
                                2487 BLC
                            </span>
                        </div>
                    </div>
                    <div className='participant-data mt-3'>
                        <span className='brand-color'>BNB Raised: 752</span>
                        <span className='brand-color'>Participants: 129</span>
                    </div>
                    <RangeSlider
                        type='range'
                        custom={true}
                        value={filled}
                        readOnly={true}
                    />
                    <div className='participant-details'>
                        <span className='brand-color-white'>10.11%</span>
                        <span className='brand-color-white'>2000 BNB</span>
                    </div>
                    <div className='allocation-details'>
                        <div className='your-allocation'>
                            <div className='brand-color-white allocation-title'>
                                Your Allocation
                            </div>
                            <div className='data'>
                                <div className='minimum-allocation'>
                                    <span className='brand-color-white'>
                                        Minimum
                                    </span>
                                    <span className='brand-color'>0.1 BNB</span>
                                </div>
                                <div className='maximum-allocation'>
                                    <span className='brand-color-white'>
                                        Maximum
                                    </span>
                                    <span className='brand-color'>5.0 BNB</span>
                                </div>
                            </div>
                        </div>
                        <div className='project-caps'>
                            <div className='brand-color-white allocation-title'>
                                Project Caps
                            </div>
                            <div className='data'>
                                <div className='soft-cap'>
                                    <span className='brand-color-white'>
                                        Softcap
                                    </span>
                                    <span className='brand-color'>500 BNB</span>
                                </div>
                                <div className='hard-cap'>
                                    <span className='brand-color-white'>
                                        Hardcap
                                    </span>
                                    <span className='brand-color'>
                                        2000 BNB
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='pool-rate'>
                        <span className='brand-color-white'>
                            Swap Rate:{" "}
                            <span className='brand-color font-weight-bold'>
                                0.000521 BNB
                            </span>
                        </span>
                        <span className='brand-color-white'>
                            Liquidity:{" "}
                            <span className='brand-color font-weight-bold'>
                                0.000575 BNB
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PoolPageDetails;
